import { EmissorOrderScreenStatus } from '../types/emissor-order-history';
export function buildMigrationOnboardingSampleOrders() {
    return [
        {
            id: 'demo-migration-onboarding-order',
            protocol: 'DEMO-EXEMPLO',
            description: 'Exemplo',
            product: { id: 'demo-migration-meal', name: 'Auxílio refeição' },
            totalAmount: 1000,
            calculationType: 'MONTHLY',
            discountType: null,
            scheduledCreditDate: '2026-08-03',
            competenceDate: '2026-08',
            status: 'PROCESSING',
            screenStatus: EmissorOrderScreenStatus.RELEASING_CREDIT,
            payment: null,
            createdAt: '2026-08-03T12:00:00.000Z',
            updatedAt: '2026-08-03T12:00:00.000Z',
        },
    ];
}
export const MIGRATION_ONBOARDING_SAMPLE_TRACKING_CARDS = [
    {
        cardTrackingId: 'demo-migration-onboarding-tracking',
        trackingCode: 'TR000000897IC',
        trackingUrl: '',
        status: 'IN_PRODUCTION',
        createdAt: '2026-08-03T12:00:00.000Z',
        updatedAt: '2026-08-03T12:00:00.000Z',
    },
];
